import { Buffer } from 'buffer';
window.Buffer = Buffer;

import './index.css'
// import { StateManager } from "./core/state";
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { initializePatcher } from './lib/patcher';

// To enable the mock server, uncomment the following line:

// Initialize the global state patcher
initializePatcher();

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )